<ul class="row mt-4">
  @for (post of posts | slice: 0 : 3; track post.id; let i = $index) {
    <li class="col-4">
      <a class="insta-post" target="_blank" [href]="post.instagramUrl">
        <img [src]="post.thumbnail" [alt]="post?.caption" />
      </a>
    </li>
  }
</ul>
